import moment from "moment";
import React, { Component } from "react";
import {
  EmailValidate,
  FormValidate,
} from "../../../../components/formValidate";
import CustomButton from "../../../../components/inputs/button";
import DatePickerField from "../../../../components/inputs/datepicker";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";
import { admin_event_add } from "../../admin.api";
import "./dialog.css";
import { DateObject } from "react-multi-date-picker";
import RichTextEditor from "@mantine/rte";

const RequiredLabel = ({ label, required }) => (
  <span className="required-label">
    {label}
    {required && <span className="required-asterisk">*</span>}
  </span>
);

const fieldLabels = {
  event_title_en: "Event Name (English)",
  event_title_ma: "Event Name (Malayalam)",
  event_date: "Event Start Date",
  event_date_to: "Event End Date",
  events_desc_en: "Description (English)",
  events_desc_ma: "Description (Malayalam)",
  event_code: "Event Code",
  event_image: "Event Thumbnail Image",
  image: "Banner Image",
  location_en: "Venue (English)",
  location_ma: "Venue (Malayalam)",
  oraganized_by_en: "Organized By (English)",
  oraganized_by_ma: "Organized By (Malayalam)",
};

let required = [
  "event_title_en",
  "event_title_ma",
  "event_date",
  "event_date_to",
  "events_desc_en",
  // "paid",
  "events_desc_ma",
  "event_code",
  // "event_title_timing",
  "event_image",
  "image",
  // "event_contact_no",
  "location_en",
  "location_ma",

  // "booking_start_date",
  // "booking_close_date",
  // "available_seats",
  // "bank_details",
  // "total_seats",
];
let OthRequired = [
  "event_title_en",
  "event_title_ma",
  "event_date",
  "event_date_to",
  "events_desc_en",
  "event_image",
  "events_desc_ma",
  "event_code",
  // "event_title_timing",
  "oraganized_by_en",
  "oraganized_by_ma",
  // "event_contact_no",
  "location_en",
  "location_ma",
  "image",

  // "available_seats",

  // "total_seats",
];

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate());
const endDateMin = new Date(tomorrow);
endDateMin.setDate(endDateMin.getDate() + 1);
let refreshKey = 1;

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      fileChanged: false,
      snackMessage: "",

      isSnackError: false,
      snackOpen: false,
    };
  }

  // componentWillReceiveProps = (props) => {
  //   this.setState({
  //     open: props.open,
  //     edit: props.edit,
  //     formData: props.formData,
  //   });
  // };
  componentWillReceiveProps = (props) => {
    if (props.open !== this.state.open || props.edit !== this.state.edit) {
      this.setState({
        open: props.open,
        edit: props.edit,
        formData: props.formData,
      });
    }
  };

  componentDidMount = () => {};
  checkStatus;
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (name === "event_code") {
      const responseError = this.state.responseErrors?.event_code?.[0] || "";
      this.setState({ eventCodeError: responseError });
      this.setState({
        formData: { ...this.state.formData, [name]: value.replace(/\s+/g, "") },
      });
    } else {
      this.setState({ formData: { ...this.state.formData, [name]: value } });
    }
  };

  handleRichChange = (name, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleEventDate = (e) => {};
  handleDatePickerChange = (e, name) => {
    let date = e.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: null,
        },
      });
    }
  };
  handleBrocureFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const sizeInMB = file.size / (1024 * 1024);
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (fileExtension === "pdf" && sizeInMB <= 5) {
      this.setState({
        fileError: false,
        formData: {
          ...this.state.formData,
          file: file,
          brochure: file.name,
        },
      });
    } else {
      this.setState({
        fileError: true,
        formData: {
          ...this.state.formData,
          file: null,
          brochure: null,
        },
        isSnackError: true,
        snackOpen: true,
        snackMessage: "Only PDF files up to 5MB are allowed.",
      });
      e.target.value = null;
    }
  };
  handleEmailChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.name === "event_email") {
      let erroremail = !EmailValidate(e.target.value);

      this.setState({
        emailError: erroremail,
      });
    }
    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };

  handleFileChange = (e) => {
    this.setState({
      isActive: true,
    });
    try {
      let flag = false;
      let type = e.target.files[0].name.split(".").pop();

      if (type === "png" || type === "jpeg" || type === "jpg") {
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;

          image.onload = function () {
            var height = this.height;
            var width = this.width;
            if (height === 258 || width === 318) {
              flag = true;
            }
          };
        };
        setTimeout(() => {
          if (flag) {
            this.setState({
              fileChanged: true,
              formData: {
                ...this.state.formData,
                file_name: e.target.files[0]?.name,
                [e.target.name]: e.target.files[0],
                isActive: false,
              },
            });
          } else {
            this.setState({
              snackMessage: "Incorrect image dimension",
              isSnackError: true,
              snackOpen: true,
              isActive: false,
            });
          }
        }, 2000);
      } else {
        this.setState({
          snackMessage: "File should be in .jpg / .jpeg / .png format",
          isSnackError: true,
          snackOpen: true,
          isActive: false,
        });
      }
    } catch {
      this.setState({
        isActive: false,
      });
    }
  };
  handleFileChangeImage = (e) => {
    this.setState({ isActive: true });

    try {
      const file = e.target.files[0];
      if (!file) return;

      const validTypes = ["png", "jpg", "jpeg"];
      const fileType = file.name.split(".").pop().toLowerCase();

      if (!validTypes.includes(fileType)) {
        this.setState({
          snackMessage: "File should be in .jpg / .jpeg / .png format",
          isSnackError: true,
          snackOpen: true,
          isActive: false,
        });
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (readerEvent) => {
        const image = new Image();
        image.src = readerEvent.target.result;

        image.onload = () => {
          const height = image.height;
          const width = image.width;

          if (width === 1250 && height === 400) {
            this.setState({
              fileChanged: true,
              formData: {
                ...this.state.formData,
                image: file,
                image_name: file.name,
              },
              isActive: false,
            });
          } else {
            this.setState({
              snackMessage: "Incorrect image dimensions. Required: 1250x400 px",
              isSnackError: true,
              snackOpen: true,
              isActive: false,
            });
          }
        };
      };
    } catch (error) {
      this.setState({ isActive: false });
    }
  };

  checkDates = () => {
    let isAddable = false;
    if (
      this.state.formData?.event_organized_type === "kspace" &&
      this.state.formData?.booking_start_date &&
      this.state.formData?.booking_close_date &&
      this.state.formData?.event_date
    ) {
      let evDate = moment(
        this.state.formData?.event_date,
        "DD-MM-YYYY",
        true
      ).format();
      let stDate = moment(
        this.state.formData?.booking_start_date,
        "DD-MM-YYYY",
        true
      ).format();
      let enDate = moment(
        this.state.formData?.booking_close_date,
        "DD-MM-YYYY",
        true
      ).format();
      if (evDate > enDate) {
        if (enDate > stDate) {
          isAddable = true;
        } else {
          isAddable = false;
          this.setState({
            snackMessage:
              "Please select valid dates for Booking Start and End Date",
            isSnackError: true,
            snackOpen: true,
            submitted: false,
          });
        }
      } else {
        isAddable = false;
        this.setState({
          snackMessage:
            "Event Date should be greater than the Booking End Date",
          isSnackError: true,
          snackOpen: true,
          submitted: false,
        });
      }
    } else {
      isAddable = true;
    }
    return isAddable;
  };
  handleSubmit = (e) => {
    let reqFields =
      this.state.formData?.event_organized_type === "kspace"
        ? required
        : OthRequired;

    const error = FormValidate(this.state.formData, reqFields);

    const { edit, formData } = this.state;
    e.preventDefault();
    this.setState({
      submitted: true,
    });

    if (
      formData?.event_image !== null &&
      formData?.event_image !== undefined &&
      formData?.event_image !== ""
    ) {
      this.setState({ isActive: true });
      let flag = this.checkDates();
      if (flag) {
        if (Object.keys(error).length === 0) {
          const form = new FormData();
          form.append("event_title_en", formData?.event_title_en);
          form.append("event_title_ma", formData?.event_title_ma);
          form.append("event_date", formData?.event_date);
          form.append("event_date_to", formData?.event_date_to);
          form.append("event_code", formData?.event_code ?? "");

          if (
            formData?.booking_start_date !== undefined &&
            formData?.booking_start_date !== null &&
            formData?.booking_start_date !== ""
          ) {
            form.append("booking_start_date", formData?.booking_start_date);
          }

          if (
            formData?.booking_close_date !== undefined &&
            formData?.booking_close_date !== null &&
            formData?.booking_close_date !== ""
          ) {
            form.append("booking_close_date", formData?.booking_close_date);
          }
          if (
            !formData?.events_desc_en ||
            formData?.events_desc_en.trim() === "" ||
            formData?.events_desc_en === "<p><br></p>"
          ) {
            {
              this.setState({
                snackMessage:
                  "Description in English and Malayalam is required.",
                isSnackError: true,
                snackOpen: true,
                isActive: false,
                submitted: false,
              });
              return;
            }
          } else {
            form.append("events_desc_en", formData?.events_desc_en);
          }
          if (
            formData?.event_title_timing !== undefined &&
            formData?.event_title_timing !== null &&
            formData?.event_title_timing !== ""
          ) {
            form.append("event_title_timing", formData?.event_title_timing);
          }
          if (
            !formData?.events_desc_ma ||
            formData?.events_desc_ma.trim() === "" ||
            formData?.events_desc_ma === "<p><br></p>"
          ) {
            {
              this.setState({
                snackMessage:
                  "Description in English and Malayalam is required.",
                isSnackError: true,
                snackOpen: true,
                isActive: false,
                submitted: false,
              });
              return;
            }
          } else {
            form.append("events_desc_ma", formData?.events_desc_ma);
          }
          form.append("location_en", formData?.location_en);
          form.append("location_ma", formData?.location_ma);
          if (formData?.file instanceof File) {
            form.append("brochure", formData?.file);
          }
          if (
            formData?.link !== undefined &&
            formData?.link !== null &&
            formData?.link !== ""
          ) {
            form.append("link", formData?.link);
          }
          if (
            formData?.total_seats !== undefined &&
            formData?.total_seats !== null &&
            formData?.total_seats !== ""
          ) {
            form.append("total_seats", formData?.total_seats);
            form.append("available_seats", formData?.total_seats);
          }
          if (formData?.event_contact_no) {
            if (formData?.event_contact_no.length === 10) {
              form.append("event_contact_no", formData?.event_contact_no);
            } else {
              this.setState({
                submitted: false,
                snackMessage: "Enter a valid 10 digit Contact Number",
                isSnackError: true,
                snackOpen: true,
              });
              return false;
            }
          }
          if (
            formData?.event_email !== undefined &&
            formData?.event_email !== null &&
            formData?.event_email !== ""
          ) {
            form.append("event_email", formData?.event_email);
          }

          form.append("file_name", formData?.file_name);
          form.append("image_name", formData?.image_name);

          if (formData?.event_organized_type === "kspace") {
            if (
              formData?.bank_details !== undefined &&
              formData?.bank_details !== null &&
              formData?.bank_details !== ""
            ) {
              form.append("bank_details", formData?.bank_details);
            }
          }
          if (formData?.event_organized_type === "kspace") {
            if (
              Array.isArray(formData?.registration_types) &&
              formData?.registration_types.length > 0
            ) {
              for (let i = 0; i < formData?.registration_types.length; i++) {
                const item = formData?.registration_types[i];

                if (
                  !item.type?.trim() ||
                  !item.days?.toString().trim() ||
                  !item.fees?.toString().trim() ||
                  !item.seat_limit?.toString().trim()
                ) {
                  this.setState({
                    submitted: false,
                    snackMessage:
                      "Please fill all registration type fields (type, days, fees,seat limit)",
                    isSnackError: true,
                    snackOpen: true,
                  });
                  return false;
                }
                if (
                  item.id !== undefined &&
                  item.id !== null &&
                  item.id.toString().trim() !== ""
                ) {
                  form.append(`registration_types[${i}][id]`, item.id);
                }
                form.append(`registration_types[${i}][type]`, item.type);
                form.append(`registration_types[${i}][days]`, item.days);
                form.append(`registration_types[${i}][fees]`, item.fees);
                form.append(
                  `registration_types[${i}][seat_limit]`,
                  item.seat_limit
                );
              }
            }
          }
          if (formData?.event_organized_type === "kspace") {
            form.append("oraganized_by_en", "KSPACE");
            form.append("oraganized_by_ma", "കെസ്‌പെയ്‌സ്");
          } else {
            form.append("oraganized_by_en", formData?.oraganized_by_en);
            form.append("oraganized_by_ma", formData?.oraganized_by_ma);
          }
          if (formData?.paid) {
            form.append("paid", formData?.paid);
          } else {
            form.append("paid", 0);
          }
          if (formData?.free) {
            form.append("free", formData?.free);
          } else {
            form.append("free", 0);
          }
          if (formData?.event_organized_type === "kspace") {
            form.append("event_organized_type", "kspace");
          } else {
            form.append("event_organized_type", "others");
          }
          if (formData?.id) form.append("event_id", formData?.id);
          if (formData?.event_image instanceof File) {
            form.append(
              "event_image",
              this.state.fileChanged ? formData?.event_image : null
            );
          }

          if (formData?.image instanceof File) {
            form.append(
              "image",
              this.state.fileChanged ? formData?.image : null
            );
          }

          admin_event_add(form)
            .then((res) => {
              this.setState({
                submitted: true,

                snackMessage: res.message,
                isSnackError: false,
                snackOpen: true,
              });
            })
            .catch((error) => {
              let message = "Something went wrong";

              if (
                error?.response?.data?.error &&
                error?.response?.data?.error?.event_code &&
                Array.isArray(error?.response?.data?.error?.event_code)
              ) {
                message = error?.response?.data?.error?.event_code[0];
              } else if (error?.message) {
                message = error?.message;
              }

              this.setState({
                submitted: false,
                snackMessage: message,
                isSnackError: true,
                snackOpen: true,
              });
            });
        } else {
          const missingFields = Object.keys(error);
          const readableFields = missingFields.map(
            (field) => fieldLabels[field] || field.replace(/_/g, " ")
          );
          const missingMessage = readableFields.length
            ? `Please fill all mandatory fields. Missing: ${readableFields.join(", ")}`
            : "Please fill all mandatory fields";
          this.setState({
            submitted: false,
            snackMessage: missingMessage,
            isSnackError: true,
            snackOpen: true,
          });
        }
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please select a valid event Image",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState({ formData: { ...this.state.formData, [name]: newValue } });
  };
  handlePhoneNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState({ formData: { ...this.state.formData, [name]: newValue } });
  };
  manageOrgType = (e) => {
    let value = e.target.value;
    if (value === "kspace") {
      this.setState({
        formData: { ...this.state.formData, event_organized_type: "kspace" },
      });
    } else {
      this.setState({
        formData: { ...this.state.formData, event_organized_type: "others" },
      });
    }
  };

  handleRegistrationTypeChange = (e, index, field) => {
    const updatedTypes = [...this.state.formData.registration_types];
    updatedTypes[index][field] = e.target.value;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        registration_types: updatedTypes,
      },
    }));
  };

  addRegistrationType = () => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        registration_types: [
          ...prevState.formData.registration_types,
          { type: "", days: "", fees: "", seat_limit: "" },
        ],
      },
    }));
  };

  removeRegistrationType = (index) => {
    const updatedTypes = [...this.state.formData.registration_types];
    updatedTypes.splice(index, 1);
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        registration_types: updatedTypes,
      },
    }));
  };

  render() {
    const { submitted, formData, open, edit, eventDate } = this.state;
    const { view } = this.props;
    console.log(formData);
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="big-dia-event-create dialog">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit ? "Edit Events" : view ? "Event" : "Add Events"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tilebar">
                  <hr />
                </div>

                <div className="row event-book-form">
                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Event Name[Eng]"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.event_title_en ?? ""}
                      name="event_title_en"
                      required
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Event Name[Mal]"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.event_title_ma ?? ""}
                      name="event_title_ma"
                      required
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Event Code"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.event_code ?? ""}
                      name="event_code"
                      required
                    />
                  </div>

                  <div className="col-6">
                    <div className="fieldset">
                      <label className="control-label mylabel">
                        <RequiredLabel label="Organized By" required />
                      </label>
                      <select
                        className="form-select input-group.mandatory disabled"
                        aria-label="Default select example"
                        name="main_category"
                        onClick={(e) => this.manageOrgType(e)}
                        disabled
                      >
                        <option
                          value="kspace"
                          selected={formData?.event_organized_type === "kspace"}
                        >
                          KSPACE
                        </option>
                        <option
                          value="other"
                          selected={formData?.event_organized_type === "others"}
                        >
                          Others
                        </option>
                      </select>
                    </div>
                  </div>
                  {formData?.event_organized_type === "others" ? (
                    <React.Fragment>
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Organizer[Eng]"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.oraganized_by_en ?? ""}
                          name="oraganized_by_en"
                          required
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Organizer[Mal]"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.oraganized_by_ma ?? ""}
                          name="oraganized_by_ma"
                          required
                        />
                      </div>
                    </React.Fragment>
                  ) : (
                    <div className="col-12">
                      <TextField
                        id="outlined-basic"
                        multiline
                        disabled={view}
                        label="Bank Details"
                        variant="outlined"
                        onChange={(e) => this.handleChange(e)}
                        value={formData?.bank_details ?? ""}
                        name="bank_details"
                        // required
                      />
                    </div>
                  )}

                  <div className="col-6 col-set">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Event Time"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.event_title_timing ?? ""}
                      name="event_title_timing"
                      // required
                    />
                  </div>

                  <div className="col-6 col-set">
                    <DatePickerField
                      value={formData?.event_date ?? null}
                      minDate={tomorrow}
                      disabled={view}
                      label="Event Start Date"
                      name="event_date"
                      required
                      onChange={(e) =>
                        this.handleDatePickerChange(e, "event_date")
                      }
                    />
                  </div>
                  <div className="col-6 col-set">
                    <DatePickerField
                      value={formData?.event_date_to ?? null}
                      minDate={
                        formData?.event_date
                          ? new DateObject({
                              date: formData?.event_date,
                              format: "DD-MM-YYYY",
                            })
                          : null
                      }
                      disabled={view}
                      label="Event End Date"
                      name="event_end_date"
                      required
                      onChange={(e) =>
                        this.handleDatePickerChange(e, "event_date_to")
                      }
                    />
                  </div>

                  {formData?.event_organized_type === "kspace" && (
                    <>
                      <div className="col-6">
                        <DatePickerField
                          // required
                          value={formData?.booking_start_date ?? null}
                          minDate={tomorrow}
                          disabled={view}
                          label="Booking Start Date"
                          // className="W-100"
                          // required
                          onChange={(e) =>
                            this.handleDatePickerChange(e, "booking_start_date")
                          }
                        />
                      </div>
                      <div className="col-6">
                        <DatePickerField
                          // required
                          value={formData?.booking_close_date ?? null}
                          minDate={new Date(this.state.formData?.event_date)}
                          disabled={view}
                          label="Booking End Date"
                          // required
                          onChange={(e) =>
                            this.handleDatePickerChange(e, "booking_close_date")
                          }
                        />
                      </div>
                    </>
                  )}
                  {formData?.event_organized_type === "kspace" && (
                    <div className="col-6">
                      <TextField
                        id="outlined-basic"
                        disabled={view}
                        label="Total Seats"
                        variant="outlined"
                        pattern="[0-9]"
                        // onChange={(e) => this.handleChange(e)}
                        onChange={(e) => this.handleNumberChange(e)}
                        value={formData?.total_seats ?? ""}
                        name="total_seats"
                      />
                    </div>
                  )}

                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Venue[Eng]"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.location_en ?? ""}
                      name="location_en"
                      multiline
                      required
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Venue[Mal]"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      value={formData?.location_ma ?? ""}
                      name="location_ma"
                      multiline
                      required
                    />
                  </div>

                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Contact Number"
                      variant="outlined"
                      maxLength="10"
                      minLength="10"
                      pattern="[0-9]{10}"
                      onChange={(e) => this.handlePhoneNumberChange(e)}
                      value={formData?.event_contact_no ?? ""}
                      name="event_contact_no"
                      type="text"
                      // required
                    />
                  </div>
                  {/* <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Email"
                      variant="outlined"
                      name="event_email"
                      // maxLength="10"
                      // minLength="10"
                      // pattern="[0-9]{10}"
                      onChange={(e) => this.handleEmailChange(e)}
                      value={formData.event_email ?? ""}
                      type="email"
                    // required
                    />
                  </div> */}

                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      label="Link"
                      name="link"
                      variant="outlined"
                      disabled={view}
                      value={formData.link ?? ""}
                      onChange={(e) => this.handleChange(e)}
                      // required
                    />
                  </div>
                  <div className="col-12">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Email"
                      variant="outlined"
                      onChange={(e) => this.handleChange(e)}
                      // required
                    />
                  </div>
                  <div className="col-12">
                    <div className="fieldset w-100 tooltip-text-editor mylabel">
                      <RequiredLabel label="Description[Eng]" required />
                    </div>

                    <RichTextEditor
                      value={this.state.formData?.events_desc_en ?? ""}
                      key={this.state.refreshKey}
                      name="events_desc_en"
                      label="Description[Eng]"
                      controls={[
                        ["bold", "italic", "underline", "link"],
                        ["unorderedList", "h1", "h2", "h3"],
                        ["sup", "sub"],
                        ["alignLeft", "alignCenter", "alignRight"],
                      ]}
                      onChange={(value) =>
                        this.handleRichChange("events_desc_en", value)
                      }
                      styles={{
                        blockquote: { color: "red", display: "inline-block" },
                        required,
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <div className="fieldset w-100 tooltip-text-editor mylabel">
                      <RequiredLabel label="Description[Mal]" required />
                    </div>

                    <RichTextEditor
                      value={this.state.formData?.events_desc_ma ?? ""}
                      key={this.state.refreshKey}
                      name="events_desc_ma"
                      controls={[
                        ["bold", "italic", "underline", "link"],
                        ["unorderedList", "h1", "h2", "h3"],
                        ["sup", "sub"],
                        ["alignLeft", "alignCenter", "alignRight"],
                      ]}
                      onChange={(value) =>
                        this.handleRichChange("events_desc_ma", value)
                      }
                      styles={{
                        blockquote: { color: "red", display: "inline-block" },
                        required,
                      }}
                    />
                  </div>

                  <div className="col-6">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Brochure"
                      name="brochure"
                      type="file"
                      accept=".pdf"
                      variant="outlined"
                      brochure={formData?.brochure}
                      fileName={formData?.brochure}
                      onChange={(e) => this.handleBrocureFileChange(e)}
                    />
                    {this.state.fileError && (
                      <div className="file-up-helper">
                        *Upload only .pdf and Size should be less than 5MB
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Image [height:258px, width : 318px ,format: .jpg , .jpeg , .png]"
                      name="event_image"
                      type="file"
                      variant="outlined"
                      required={formData?.file_name ? false : true}
                      fileName={formData?.file_name}
                      onChange={(e) => this.handleFileChange(e)}
                    />
                  </div>
                  <div className="col-12">
                    <TextField
                      id="outlined-basic"
                      disabled={view}
                      label="Image [height:400px, width : 1250px ,format: .jpg , .jpeg , .png]"
                      name="image"
                      type="file"
                      variant="outlined"
                      required={formData?.image_name ? false : true}
                      fileName={formData?.image_name ?? ""}
                      onChange={(e) => this.handleFileChangeImage(e)}
                    />
                  </div>
                  {formData?.event_organized_type === "kspace" && (
                    <div className="col-12">
                      <div className="fieldset">
                        <label className="control-label mylabel">
                          <RequiredLabel label="Registration Types" required />
                        </label>

                        {!view &&
                          this.state.formData?.registration_types?.map(
                            (item, index) => (
                              <div
                                key={index}
                                className="row mb-2 align-items-end"
                              >
                                <div className="col-2">
                                  <TextField
                                    label="Type"
                                    variant="outlined"
                                    value={item.type}
                                    onChange={(e) =>
                                      this.handleRegistrationTypeChange(
                                        e,
                                        index,
                                        "type"
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <TextField
                                    label="Duration"
                                    variant="outlined"
                                    value={item.days}
                                    onChange={(e) =>
                                      this.handleRegistrationTypeChange(
                                        e,
                                        index,
                                        "days"
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <TextField
                                    label="Fees"
                                    type="number"
                                    variant="outlined"
                                    value={item.fees}
                                    onChange={(e) =>
                                      this.handleRegistrationTypeChange(
                                        e,
                                        index,
                                        "fees"
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <TextField
                                    label="Seat Limit"
                                    variant="outlined"
                                    value={item.seat_limit}
                                    onChange={(e) =>
                                      this.handleRegistrationTypeChange(
                                        e,
                                        index,
                                        "seat_limit"
                                      )
                                    }
                                  />
                                </div>

                                <div className="col-3 pb-2">
                                  <button
                                    type="button"
                                    className="commonButtonbutton me-2"
                                    onClick={() => this.addRegistrationType()}
                                  >
                                    ➕
                                  </button>
                                  {this.state.formData?.registration_types
                                    .length > 1 && (
                                    <button
                                      type="button"
                                      className="dangerButtonbutton"
                                      onClick={() =>
                                        this.removeRegistrationType(index)
                                      }
                                    >
                                      ➖
                                    </button>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 event-dia-action">
                    <CustomButton
                      label={edit ? "Update" : "Add"}
                      disabled={submitted}
                      onClick={(e) => this.handleSubmit(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
